// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Locale } from 'date-fns';
import {
  af,
  arSA,
  bg,
  cs,
  cy,
  da,
  de,
  deAT,
  enCA,
  enGB,
  enUS,
  es,
  eu,
  faIR,
  fi,
  fr,
  frCA,
  he,
  hr,
  hu,
  id,
  is,
  it,
  ja,
  ko,
  lt,
  lv,
  mn,
  nl,
  nn,
  pl,
  pt,
  ptBR,
  ro,
  ru,
  sk,
  sl,
  sr,
  sv,
  th,
  tr,
  uk,
  vi,
  zhCN,
  zhTW,
} from 'date-fns/locale';

const dateFnsLocales = {
  en: undefined,
  uk,
  'en-GB': enGB,
  'en-US': enUS,

  de,
  'de-DE': de,
  'de-AT': deAT,

  'af-ZA': af,
  ar: arSA,
  'bg-BG': bg,
  'ca-AD': enCA,
  'cs-CZ': cs,
  'cy-GB': cy,
  'da-DK': da,
  'es-CL': es,
  'es-ES': es,
  'es-MX': es,
  eu,
  'fa-IR': faIR,
  'fi-FI': fi,
  'fr-CA': frCA,
  'fr-FR': fr,
  'he-IL': he,
  'hr-HR': hr,
  'hu-HU': hu,
  'id-ID': id,
  'is-IS': is,
  'it-IT': it,
  'ja-JP': ja,
  'ko-KR': ko,
  'lt-LT': lt,
  'lv-LV': lv,
  'mn-MN': mn,
  'nb-NO': nn,
  'nl-NL': nl,
  'nn-NO': nn,
  'pl-PL': pl,
  'pt-BR': ptBR,
  'pt-PT': pt,
  'ro-RO': ro,
  'ru-RU': ru,
  'sk-SK': sk,
  'sl-SI': sl,
  'sr-RS': sr,
  'sv-SE': sv,
  'th-TH': th,
  'tr-TR': tr,
  'uk-UA': uk,
  'vi-VN': vi,
  'zh-CN': zhCN,
  'zh-TW': zhTW,
} as const;

export type SupportedDateLocales = 'en' | keyof typeof dateFnsLocales;

export function getDateFnsLocale(localeString: SupportedDateLocales): Locale | undefined {
  const locale = dateFnsLocales[localeString];
  return locale;
}
